module.exports = __webpack_public_path__ + "static/media/money-bill-wave.1b5ff4d8.svg";